// extracted by mini-css-extract-plugin
module.exports = {"forgotPassword":"styles_forgotPassword__crCy0","inner":"styles_inner__vQ9oa","spinner":"styles_spinner___tZN_"};